module.exports = __webpack_public_path__ + "static/media/chart-mixed.eb03c44f.svg";